import CommentsWrapper from "./CommentsWrapper";
import CommentMedia from "./CommentMedia";
import CommentForm from "./CommentForm";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faFolder,
  faTag,
  faEye,
} from "@fortawesome/free-solid-svg-icons";

export default function Post({
  postTitle,
  postHref,
  publishedOn,
  postBody,
  imgSrc,
  category,
  viewCount,
  children,
  tags,
}) {
  const altImg = process.env.PUBLIC_URL + "/img/blog/1.png";

  return (
    <>
      <div className="card blog mb-4">
        <div className="blog-header">
          <img className="card-img-top" src={imgSrc ? imgSrc : altImg} alt="" />
        </div>
        <div className="card-body text-right">
          <h5 className="card-title">
            <span>{postTitle}</span>
          </h5>
          <div className="entry-meta">
            <ul className="tag-info list-inline pr-0">
              <li className="list-inline-item">
                <span>
                  <FontAwesomeIcon icon={faCalendar} />
                </span>{" "}
                {publishedOn}
              </li>
              <li className="list-inline-item">
                <span>
                  <FontAwesomeIcon icon={faFolder} />
                </span>{" "}
                {category}
              </li>
              {tags && (
                <li className="list-inline-item">
                  <span>
                    <FontAwesomeIcon icon={faTag} />
                  </span>
                  {tags}
                </li>
              )}

              <li className="list-inline-item" style={{ marginRight: "5px" }}>
                <span>
                  <FontAwesomeIcon icon={faEye} />
                </span>
                <div style={{ display: "inline-block", marginRight: "3px" }}>
                  {viewCount} بازدید
                </div>
              </li>
            </ul>
          </div>

          <>{children}</>

          <footer className="entry-footer">
            <div className="blog-post-tags">
              {tags && (
                <ul className="list-inline pr-0">
                  <li className="list-inline-item">
                    <FontAwesomeIcon icon={faTag} /> تگ ها:
                  </li>
                  <li className="list-inline-item">
                    <a rel="tag" href="#">
                      {tags}
                    </a>
                  </li>
                </ul>
              )}
            </div>
          </footer>
        </div>
      </div>

      {/* <CommentsWrapper>
        <CommentMedia
          commentBody="این متن یک کامنت تست می باشد."
          commentAuthor="هلیا بیگدلی"
          commentDate="5 آبان، 1376"
        />
        <CommentMedia
          commentBody="این متن یک کامنت تست می باشد."
          commentAuthor="فاطمه سادات عظیمی"
          commentDate="5 آبان، 1376"
        >
          <CommentMedia
            commentBody="این متن یک کامنت تست می باشد."
            commentAuthor="رایا منصوری"
            commentDate="5 آبان، 1376"
          />
        </CommentMedia>
        <CommentMedia
          commentBody="این متن یک کامنت تست می باشد."
          commentAuthor="زهرا سادات عظیمی"
          commentDate="5 آبان، 1376"
        />
      </CommentsWrapper> */}

      {/* <CommentForm /> */}
    </>
  );
}
